import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import {BrowserRouter as Router} from "react-router"
import config from '../config'
import { seedPrototypeData } from './data/sample'

if (config.appMode === 'prototype') {
  seedPrototypeData();
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Router>
      <App/>
    </Router>
  </StrictMode>,
)
